module.exports = __webpack_public_path__ + "img/zhifu.066e1d5a.png";